export function getLayoutMethods({ getAppLayout, defaultDialogTitle, cancelButtonText, okButtonText }) {
    function showErrorDialog(title, message, showHtml, preserveSpace, errorMetadata) {
        const appLayout = getAppLayout();
        return appLayout.showErrorDialog(title, message, showHtml, preserveSpace, errorMetadata);
    }
    function closeErrorDialog() {
        const appLayout = getAppLayout();
        appLayout.showErrorDialog();
    }
    function showDialog(options) {
        const appLayout = getAppLayout();
        return appLayout.showGenericDialog(options);
    }
    function closeDialog(closeOptions) {
        const appLayout = getAppLayout();
        appLayout.closeGenericDialog(closeOptions);
    }
    function getExportedCssVars() {
        const appLayout = getAppLayout();
        return appLayout.getExportedCssVars();
    }
    function registerAccessibilityViolation(violation) {
        const appLayout = getAppLayout();
        appLayout.registerAccessibilityViolation(violation);
    }

    /**
     * Show a basic confirmation dialog with a certain title and simple text message.
     * Returns true if the user selects OK and false if CANCEL. Must be awaited.
     * @param {*} title
     * @param {*} message
     */
    async function showConfirmationDialog(title, message) {
        const okResult = "OK";
        const cancelResult = "CANCEL";

        const actualTitle = title ? title : defaultDialogTitle;
        const result = await showDialog({
            title: actualTitle,
            message,
            buttons: [
                {
                    text: cancelButtonText,
                    result: cancelResult
                },
                {
                    text: okButtonText,
                    primary: true,
                    result: okResult
                }
            ]
        });
        return result === okResult;
    }
    return {
        showErrorDialog,
        closeErrorDialog,
        showDialog,
        closeDialog,
        showConfirmationDialog,
        getExportedCssVars,
        registerAccessibilityViolation
    };
}
